import CommentsEnum from '../enumerators/comments.enum'

export default class CommentsAction {
    constructor() {
        CommentsAction.init()
        CommentsAction.onClick()
        CommentsAction.onClickNext()
        CommentsAction.onClickPrev()
        CommentsAction.onSubmit()
    }

    static init() {
        const paged = 1
        $.ajax({
            url: IRISCollectionTheme.ajaxUrl, // eslint-disable-line
            type: 'post',
            data: {
                action: 'ajax_comment_pagination',
                postId: CommentsEnum.CURRENT_POST,
                paged,
            },
            success(result) {
                $(CommentsEnum.LOADER).fadeOut()
                $(CommentsEnum.WRAPPER).html(result)
                $(CommentsEnum.PAGINATION).attr('data-current-page', paged)
                CommentsAction.disableButton(paged)
            },
        })
    }

    static onClick() {
        //Click on numbers
        $(document).on('click', CommentsEnum.PAGINATION_NUMBER, function (event) {
            event.preventDefault()
            const paged = $(this).attr('data-page')
            $(CommentsEnum.LOADER).fadeIn()

            $.ajax({
                url: IRISCollectionTheme.ajaxUrl, // eslint-disable-line
                type: 'post',
                data: {
                    action: 'ajax_comment_pagination',
                    postId: CommentsEnum.CURRENT_POST,
                    paged,
                },
                success(result) {
                    $(CommentsEnum.LOADER).fadeOut()
                    $(CommentsEnum.WRAPPER).html(result)
                    $(CommentsEnum.PAGINATION).attr('data-current-page', paged)
                    $(CommentsEnum.PAGINATION_NUMBER).removeClass('active')
                    $('[data-page="' + paged + '"]').addClass('active')
                    CommentsAction.disableButton(paged)
                },
            })
        })
    }

    static onClickNext() {
        //Click on next button
        $(document).on('click', CommentsEnum.NEXT, (event) => {
            event.preventDefault()
            const current = Number.parseInt($(CommentsEnum.PAGINATION).attr('data-current-page'))
            const next = current + 1

            if (next <= Number.parseInt($(CommentsEnum.PAGINATION).attr('data-count-page'))) {
                $(CommentsEnum.LOADER).fadeIn()
                $.ajax({
                    url: IRISCollectionTheme.ajaxUrl, // eslint-disable-line
                    type: 'post',
                    data: {
                        action: 'ajax_comment_pagination',
                        postId: CommentsEnum.CURRENT_POST,
                        paged: next,
                    },
                    success(result) {
                        $(CommentsEnum.LOADER).fadeOut()
                        $(CommentsEnum.WRAPPER).html(result)
                        $(CommentsEnum.PAGINATION).attr('data-current-page', next)
                        $(CommentsEnum.PAGINATION_NUMBER).removeClass('active')
                        $('[data-page="' + next + '"]').addClass('active')
                        CommentsAction.disableButton(next)
                    },
                })
            }
        })
    }

    static onClickPrev() {
        //Click on next button
        $(document).on('click', CommentsEnum.PREV, (event) => {
            event.preventDefault()
            const current = Number.parseInt($(CommentsEnum.PAGINATION).attr('data-current-page'))
            const prev = current - 1

            if (prev > 0) {
                $(CommentsEnum.LOADER).fadeIn()
                $.ajax({
                    url: IRISCollectionTheme.ajaxUrl, // eslint-disable-line
                    type: 'post',
                    data: {
                        action: 'ajax_comment_pagination',
                        postId: CommentsEnum.CURRENT_POST,
                        paged: prev,
                    },
                    success(result) {
                        $(CommentsEnum.LOADER).fadeOut()
                        $(CommentsEnum.WRAPPER).html(result)
                        $(CommentsEnum.PAGINATION).attr('data-current-page', prev)
                        $(CommentsEnum.PAGINATION_NUMBER).removeClass('active')
                        $('[data-page="' + prev + '"]').addClass('active')
                        CommentsAction.disableButton(prev)
                    },
                })
            }
        })
    }

    static disableButton(paged) {
        if (paged === Number.parseInt($(CommentsEnum.PAGINATION).attr('data-count-page'))) {
            $(CommentsEnum.NEXT).css('opacity', 0.5)
        } else {
            $(CommentsEnum.NEXT).css('opacity', 1)
        }

        if (paged === 1) {
            $(CommentsEnum.PREV).css('opacity', 0.5)
        } else {
            $(CommentsEnum.PREV).css('opacity', 1)
        }
    }

    static onSubmit() {
        document.forms.commentform.addEventListener(
            'submit',
            (e) => {
                e.preventDefault()
                document.forms.commentform.reportValidity()
                if (document.forms.commentform.reportValidity() === true) {
                    document.getElementById('commentform').submit()
                }
            },
            false,
        )
    }
}
